import { gql } from '@apollo/client';

export const GET_LANGUAGES = gql`
  query getLanguages {
    languages(criteria: { filters: { availableInApp: { operation: EQ, value: true } }}) {
      items {
        _id
        key
        name
      }
    }
  }
`;
